import { LoyaltyFeedCardType } from '@fgb/core';

export interface RewardTypeConfig {
  label: string;
  route: string;
  button: string;
}

export type RewardCardType =
  | LoyaltyFeedCardType.MarketplaceItem
  | LoyaltyFeedCardType.MarketplaceEvent
  | LoyaltyFeedCardType.Auction
  | LoyaltyFeedCardType.Lotto;

export const REWARD_TYPE_CONFIG: Record<RewardCardType, RewardTypeConfig> = {
  [LoyaltyFeedCardType.MarketplaceItem]: {
    label: 'fgbcl.feed.item.marketplace.title',
    route: '/rewards/marketplace/details',
    button: 'marketplace-redeem-now',
  },
  [LoyaltyFeedCardType.MarketplaceEvent]: {
    label: 'fgbcl.feed.item.event.title',
    route: '/rewards/marketplace/details',
    button: 'marketplace.redeem.event',
  },
  [LoyaltyFeedCardType.Auction]: {
    label: 'fgbcl.feed.item.auction.title',
    route: '/rewards/auctions/details',
    button: 'auction.bid.now',
  },
  [LoyaltyFeedCardType.Lotto]: {
    label: 'fgbcl.feed.item.lotto.title',
    route: '/rewards/raffles/details',
    button: 'lottos.enter.now',
  },
};
